import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { State } from 'src/app/store';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntil, tap } from 'rxjs/operators';
import { UpdateAccessAction, UpdateAccessSuccessAction, UpdateAccessErrorAction } from 'src/app/global/store/global.actions';
import { AccessControlService } from 'src/app/global/services/access-control/access-control.abstract.service';
import { AccessControl, UpdateRoleDto } from 'src/app/global/services/access-control/access-control.model';

@Component({
    selector: 'app-access-control-edit',
    templateUrl: './access-control-edit.component.html',
    styleUrls: ['./access-control-edit.component.scss'],
})
export class AccessControlEditComponent implements OnInit {
    destroy$ = new Subject();

    accessId = '';

    access: AccessControl;

    loading = false;
    submitLoading = false;

    constructor(
        private route: ActivatedRoute,
        private accessService: AccessControlService,
        private router: Router,
        private store: Store<State>,
        private actions$: Actions,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.accessId = params.get('id');
        });

        this.loading = true;

        this.accessService
            .getRole(this.accessId)
            .pipe(
                tap(() => {
                    this.loading = false;
                }),
                takeUntil(this.destroy$),
            )
            .subscribe((access) => {
                this.access = access;
            });
    }

    handleSubmit(access: AccessControl): void {
        this.submitLoading = true;

        const updatePayload: UpdateRoleDto = {
            key: access.key,
            title: access.title,
            description: access.description,
            permissions: access.permissions,
            type: access.type,
            scopes: access.scopes,
        };

        this.store.dispatch(UpdateAccessAction({ access: updatePayload, roleId: access._id }));

        this.actions$
            .pipe(
                ofType(UpdateAccessSuccessAction, UpdateAccessErrorAction),
                tap(() => (this.submitLoading = false)),
                ofType(UpdateAccessSuccessAction),
                tap(() => this.store.dispatch(UpdateAccessSuccessAction({ access }))),
                tap(() => this.router.navigate(['access-contol'])),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
